import type { IPresetColor } from '../types/colorPicker';

export const PRESETCOLORS: IPresetColor[] = [
    { id: '0', color: 'rgba(0,0,0,1)' },
    { id: '1', color: 'rgba(67,67,67,1)' },
    { id: '2', color: 'rgba(102,102,102,1)' },
    { id: '3', color: 'rgba(153,153,153,1)' },
    { id: '4', color: 'rgba(183,183,183,1)' },
    { id: '5', color: 'rgba(204,204,204,1)' },
    { id: '6', color: 'rgba(217,217,217,1)' },
    { id: '7', color: 'rgba(239,239,239,1)' },
    { id: '8', color: 'rgba(243,243,243,1)' },
    { id: '9', color: 'rgba(255,255,255,1)' },
    { id: '10', color: 'rgba(244,67,54,1)' },
    { id: '11', color: 'rgba(255,152,0,1)' },
    { id: '12', color: 'rgba(255,235,59,1)' },
    { id: '13', color: 'rgba(139,195,74,1)' },
    { id: '14', color: 'rgba(76,175,80,1)' },
    { id: '15', color: 'rgba(0, 150, 136,1)' },
    { id: '16', color: 'rgba(15,109,126,1)' },
    { id: '17', color: 'rgba(3,169,244,1)' },
    { id: '18', color: 'rgba(0,94,184,1)' },
    { id: '19', color: 'rgba(63,81,181,1)' },
    { id: '20', color: 'rgba(156,39,176,1)' },
    { id: '21', color: 'rgba(121,85,72,1)' },
];

export const ITEM_STORAGE_URL = 'https://cube.tobit.cloud/item-storage/api/v1.0';
